module.exports = __webpack_public_path__ + "static/media/placeholder-photo.73a64553.jpg";